export default __webpack_public_path__ + "static/media/dv.88dce712.svg";